const initialState = {
	BASE_URL: undefined,
	CONTENT_API_URL: undefined,
	USER_AUTH_API_URL: undefined,
	QUOTE_API_URL: undefined,
	OAUTH_API_URL: undefined,
	ADYEN_CLIENT_ID: undefined,
	GOOGLE_API_KEY: undefined,
	GTM_ID: undefined,
	AB_TASTY_TAG_ID: undefined,
	NAV_LOGS_API_URL: undefined,
	ENVIRONMENT: undefined,
	ONE_TRUST_SCRIPT: undefined,
	DATADOG_SESSION_SAMPLE_RATE: undefined,
	ALGOLIA_API_KEY: undefined,
	ALGOLIA_APP_ID: undefined,
};

export default (envVars = initialState) => {
	return envVars;
};
